<template>
  <div class="page">
    <dashboard-header></dashboard-header>
    
    <div class="content">
      <div class="container-fluid">
        
        <div class="card">
          <div class="card-body">
            
            <div id="quote-step1" v-show="step == 0">
              <h2>Please Enter the Search Term to Suppress</h2>
              
              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text">Search Term</div>
                </div>
                <input type="text" :class="`form-control ${errors.noSearchTerm ? 'is-invalid' : ''}`" v-model="searchTerm" v-on:keyup.enter="moveStep(1)" />
                <button class="btn btn-primary" @click="moveStep(1)">Next</button>
              </div>
            </div>
            
            <div id="quote-step2" v-show="step == 1">
              <h2>Please Choose Where to Run the Search From</h2>
              
              <h3>Searching For: {{searchTerm}}</h3>
              
              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text" style="min-width: 150px;">Search Country</div>
                </div>
                <select class="form-control" v-model="searchCountry" @change="updateSearchOptions">
                  <option value="US">United States</option>
                  <option value="GB">United Kingdom</option>
                  <option value="CA">Canada</option>
                </select>
              </div>
              
              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text" style="min-width: 150px;">Search State</div>
                </div>
                <select :class="`form-control ${errors.noSearchState ? 'is-invalid' : ''}`" v-model="searchState" @change="updateSearchOptions">
                  <option value="">None Selected</option>
                  
                  <option v-for="state in searchStateOptions.states" v-bind:value="state.state">{{state.state}}</option>
                </select>
              </div>
              
              <div class="input-group">
                <div class="input-group-prepend">
                  <div class="input-group-text" style="min-width: 150px;">Search City</div>
                </div>
                <select :class="`form-control ${errors.noSearchCity ? 'is-invalid' : ''}`" v-model="searchCity" @change="updateSearchOptions">
                  <option value="">None Selected</option>
                  
                  <option v-for="city in searchCityOptions.cities" v-bind:value="city.city">{{city.city}}</option>
                </select>
              </div>
              
              <button class="btn btn-primary" @click="moveStep(1)">Next</button>
            </div>
            
            <div id="quote-step3" v-show="step == 2">
              <h2>Choose Positive &amp; Negative Links</h2>
              <h3>Search Term: {{searchTerm}}</h3>
              <h3>Search Location: {{searchCity}}, {{searchState}} - {{searchCountry}}</h3>
              
              <div style="text-align:center;" v-if="loadingMangools"><img src="../assets/ajax-loader.gif" /><br /><br />One moment while I collect the results</div>
              
              <client-pages-table v-show="!loadingMangools" @itemUpdated="linkUpdated" client-id="QUOTE" v-bind:mangools-data="mangoolsData" source="mangoolsData" v-bind:can-save="canSave" v-bind:view-mangools-data="viewMangools"></client-pages-table>
              
              <div v-if="recommendedPackage">
                <h2>Recommended Package</h2>
                
                <h3>Keyword Rank {{mangoolsData[0].rank}} <span v-show="recommendedPackage.highestDA > mangoolsData[0].rank">(Domain Authority is Higher {{recommendedPackage.highestDA}})</span></h3>
                
                <table class="table">
                  <tr>
                    <td>Tier</td>
                    <td>{{recommendedPackage.tier}}</td>
                  </tr>
                  <tr>
                    <td>Level</td>
                    <td>{{recommendedPackage.level}}</td>
                  </tr>
                </table>
                
                <h2>Take Screenshots</h2>
                
                <h3>You need the extension installed for this to work. Make sure all links are tagged positive/negative first.</h3>
                
                <button class="btn btn-primary" @click="takeScreenshots">Click here to begin the screenshotting process.</button>
              </div>
            </div>
            
          </div>
        </div>
        
      </div>
    </div>
    
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
  import ClientPagesTable from "./ClientPagesTable.vue";
  import DashboardHeader from "./DashboardHeader.vue";
  import DashboardFooter from "./DashboardFooter.vue";
  import WebLLCRESTApi from "../api/api";
  import {countries} from "../util/geotargets.js";
  
  export default {
    created() {
      this.api = new WebLLCRESTApi("Mangools", this.$router);
      this.apiQuotes = new WebLLCRESTApi("Quotes", this.$router);
      this.updateSearchOptions();
    },
    
    data() {
      return {
        errors: {},
        step: 0,
        searchTerm: "",
        searchCountry: "US",
        searchState: "",
        searchStateOptions: {},
        searchCity: "",
        searchCityOptions: {},
        mangoolsData: null,
        loadingMangools: false,
        recommendedPackage: null,
        canSave: true,
        viewMangools: true
      }
    },
    
    methods: {
      async moveStep(relativeStep) {
        if(this.verifyStep(this.step)) {
          this.step += relativeStep;
          
          // load mangools data after search & location set
          if(this.step == 2) {
            this.loadingMangools = true;
            this.mangoolsData = await this.loadMangools(this.searchTerm, this.getSearchLocationId(this.searchCountry, this.searchState, this.searchCity));
            this.loadingMangools = false;
          }
        }
      },
      
      verifyStep(step) {
        this.errors = {};
        
        if(step == 0) {
          if(!this.searchTerm) {
            this.errors.noSearchTerm = true;
            return false;
          }
        }
        else if(step == 1) {
          if(!this.searchState) {
            this.errors.noSearchState = true;
            return false;
          }
          if(!this.searchCity) {
            this.errors.noSearchCity = true;
            return false;
          }
        }
        else if(step == 2) {
          return true;
        }
        
        return true;
      },
      
      updateSearchOptions() {
        if(this.searchCountry !== this.searchStateOptions.code) {
          this.searchStateOptions = countries.filter((country) => country.code == this.searchCountry)[0];
          this.searchState = "";
        }
        
        if(this.searchState !== this.searchCityOptions.state) {
          this.searchCity = "";
          const cities = this.searchStateOptions.states.filter((item) => item.state == this.searchState);
          
          if(cities.length > 0) {
            this.searchCityOptions = cities[0];
          }
          else {
            this.searchCityOptions = { id: 0, state: "", cities: [] };
          }
        }
      },
      
      getSearchLocationId(searchCountry, searchState, searchCity) {
        const foundCountry = countries.filter((country) => country.code == searchCountry)[0];
        const foundState = foundCountry.states.filter((item) => item.state == searchState);
        
        if(foundState.length > 0) {
          const foundCity = foundState[0].cities.filter((item) => item.city == searchCity);
          
          if(foundCity.length > 0) {
            return foundCity[0].id;
          }
          else {
            return foundState[0].id;
          }
        }
        else {
          return foundCountry.id;
        }
      },
      
      async takeScreenshots() {
        // save this quote to the server
        await this.apiQuotes.addData({
          type: "googlesearch-MangoolsV3",
          keyword: this.searchTerm,
          locationId: this.getSearchLocationId(this.searchCountry, this.searchState, this.searchCity),
          serpApiJson: JSON.stringify(this.mangoolsData)
        });
        
        // dispatch a custom event that the extension will pick up
        const evt = new CustomEvent('screenshotQuote', {
          detail: {
            searchType: "googlesearch",
            searchData: this.mangoolsData
          }
        });
        
        document.dispatchEvent(evt);
      },
      
      async loadMangools(searchTerm, locationId) {
        const mangoolsResult = await this.api.remoteMethod(locationId + "/" + encodeURIComponent(searchTerm) + "/false");
        
        if(mangoolsResult.status == 200) {
          return await mangoolsResult.json();
        }
        else {
          throw new Error("Failed to load mangools data: " + mangoolsResult.status);
        }
      },
      
      linkUpdated() {
        this.recommendedPackage = this.getRecommendedPackage(this.mangoolsData);
      },
      
      getRecommendedPackage(mangoolsData) {
        const keywordDifficulty = mangoolsData[0].rank;
        const negativesPage1 =
          mangoolsData[0].items
            .filter((item) => item.linkType == "negative");
        const highestNegativesDAPage1 =
          negativesPage1
            .sort((a, b) => this.getDA(b) - this.getDA(a));
        const highestNegativeDAPage1 = (highestNegativesDAPage1.length > 0 ? this.getDA(highestNegativesDAPage1[0]) : 0);
        
        if(negativesPage1.length <= 5) {
          const tiersByNegativeLinks = ["1 - Professional (No Negatives on Page 1)", "1 - Professional", "1 - Professional", "2 - Executive", "2 - Executive", "3 - VIP"];
          
          return {
            tier: tiersByNegativeLinks[negativesPage1.length],
            level: Math.max(this.getKWLevel(keywordDifficulty), this.getDomainLevel(highestNegativeDAPage1)),
            highestDA: highestNegativeDAPage1
          };
        }
        else {
          return {
            tier: "3 - VIP",
            level: "Please contact Darren to set up strategy (too many negative links on page 1) - [Lvl " + Math.max(this.getKWLevel(keywordDifficulty), this.getDomainLevel(highestNegativeDAPage1)) + "]",
            highestDA: highestNegativeDAPage1
          };
        }
      },
      
      getDA(item) {
        return (item.m && item.m.moz ? item.m.moz.v.pda : 0);
      },
      
      getKWLevel(kwDifficulty) {
        if(kwDifficulty < 34) {
          return 1;
        }
        else if(kwDifficulty < 67) {
          return 2;
        }
        else {
          return 3;
        }
      },
      
      getDomainLevel(da) {
        if(da < 34) {
          return 1;
        }
        else if(da < 67) {
          return 2;
        }
        else {
          return 3;
        }
      }
    },
    
    components: {
      ClientPagesTable,
      DashboardHeader,
      DashboardFooter
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Quoting.vue